import { TransactionsFilters } from './types';

export const DEFAULT_FILTERS: TransactionsFilters = {
  search: '',
  id: null,
  ofId: null,
  ofCompanyId: null,
  companyId: null,
  modelId: null,
  ofModelId: null,
  createdAtStart: null,
  createdAtEnd: null,
  models: [],
  accounts: [],
  status: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const TABLE_COLUMNS = [
  { key: 'id', name: 'ID' },
  { key: 'campaign', name: 'Campaign' },
  { key: 'user', name: 'User' },
  { key: 'status', name: 'Status' },
  { key: 'amount', name: 'Amount' },
  { key: 'createdAt', name: 'Subscription Date' },
];

export const getTableColumns = (t: (key: string) => string, total?: any) => [
  { key: 'id', name: t('transactions.table.columns.id') },
  { key: 'campaign', name: t('transactions.table.columns.campaign') },
  { key: 'user', name: t('transactions.table.columns.user') },
  { key: 'status', name: t('transactions.table.columns.status') },
  { key: 'amount', name: t('transactions.table.columns.amount'), total: `$${total}` || null },
  { key: 'createdAt', name: t('transactions.table.columns.createdAt') },
];

export const MODELS_PAGE_SIZE = 20;
export const MODEL_SEARCH_DEBOUNCE_DELAY = 300;
